






















import { Component, Vue, Prop } from "vue-property-decorator";

@Component({})
export default class SelectYearAndMonth extends Vue {
  @Prop({
    default: () => ({
      year: new Date().getFullYear(),
      month: new Date().getMonth() + 1
    })
  })
  values!: { year: number; month: number };
  @Prop() okTitle!: string;

  get yearOptions() {
    const y = new Date().getFullYear();
    return new Array(10).fill(0).map((_, i) => ({
      text: `${y + i - 5}年`,
      value: y + i - 5
    }));
  }

  get monthOptions() {
    return new Array(12).fill(0).map((_, i) => ({
      text: `${i + 1}月`,
      value: i + 1
    }));
  }

  ok() {
    this.$emit("ok", this.values.year, this.values.month);
  }

  changeYear(year: number) {
    this.values.year = year;
    this.$emit("change-year", year);
  }

  changeMonth(month: number) {
    this.values.month = month;
    this.$emit("change-month", month);
  }
}
